import type { IconProps } from 'common-types';

export const AngleDown = ({ width = 24, height = 24, fill }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 24 24`}
    fill={fill ?? 'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M12 13.2399L15.7808 9.38017C15.9148 9.24346 16.0964 9.16667 16.2858 9.16667C16.4753 9.16667 16.6569 9.24346 16.7909 9.38017C16.9248 9.51691 17 9.70236 17 9.89572C17 10.0891 16.9248 10.2745 16.7909 10.4113L12.505 14.7865C12.3711 14.9232 12.1894 15 12 15C11.8106 15 11.6289 14.9232 11.495 14.7865L7.20914 10.4113C7.07523 10.2745 7 10.0891 7 9.89572C7 9.70236 7.07523 9.51691 7.20914 9.38017C7.34309 9.24346 7.52475 9.16667 7.71415 9.16667C7.90356 9.16667 8.08522 9.24346 8.21917 9.38017L12 13.2399Z" fill={fill ?? '#14171A'} stroke={fill ?? '#14171A'} strokeWidth="0.5"/>
  </svg>
);
